import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import * as React from 'react';
export default {
  FontAwesomeIcon,
  faChevronCircleRight,
  React
};